import React from 'react'
import Box from '@material-ui/core/Box'
import MultiSessionInput from 'components/multi-session-input'
import { useStyles } from '../styles'

const ScheduleSessions = ({ timezone }) => {
  const classes = useStyles()

  return (
    <Box className={classes.fieldGroup}>
      <MultiSessionInput name="sessions" timezone={timezone} variant="edit" />
    </Box>
  )
}

export default ScheduleSessions
